import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormDrawer from "../common/form-drawer";
import { FileUploader } from "react-drag-drop-files";
import FileUploadUI from "components/__new/common/form/FileUploadUI";
import getFileSize from "utils/getFileSize";
import Maybe from "components/__new/common/Maybe";
import Select from 'react-select'
import iconCSV from "assets/images/icons/uploadcloud.svg";
import { jsonToFormData } from "utils/jsonToFormData";
import iconDocCsv from "assets/images/icons/csvfile.svg";
import redBinIcon from "assets/images/icons/binbin.svg";
import { toast } from "react-toastify";
import { Input, ButtonLoader } from "components/__new/common/form";
import * as employeesActions from "store/entities/employees/action";
import * as banksActions from "store/ui/banks/action";
import { ReactComponent as CloseOutIcon } from "assets/images/icons/closeout.svg";
import { ReactComponent as BulkAlertMessage } from "assets/images/icons/bulkalert.svg";
import { ReactComponent as DownloadIcon } from "assets/images/icons/downloadicon.svg";
import successGif from "assets/images/icons/success-green.gif";
import useLoginInfo from "hooks/useLoginInfo";

const BulkUpload = (props) => {
    const {userInfo} = useLoginInfo();
    const {isOpen, setIsOpen, setUploadJobId, setIsOpenBulkUploadReview, getEmployees } = props;
    const dispatch = useDispatch();
    const { employeeCreateLoading, employeeBulkPreviewSuccess, employeeBulkPreview, employeeBulkPreviewLoading, employeeUploadLoading, employeeCreateStatus, employeeCreateSuccess } = useSelector((s) => s.entities.employees);
    

    const [bulkUpload, setBulkUpload] = useState(null);
    const [showBanks, setShowBanks] = useState(false);
    const [isBulkUploadSuccess, setIsBulkUploadSuccess] = useState(false);
    
    const { banks, banksLoading } = props;
    const [options, setOptions] = useState([]);


    useEffect(() => {
        dispatch(banksActions.getAllBanks());
        // eslint-disable-next-line
    }, []);
    


    useEffect(() => {
        if (banks?.error === false && banks){
            if (banks?.length > 0){
                const data = banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((bank) => {
                    return {
                        bankName: (bank?.bankName?.toLowerCase() || bank?.institutionName?.toLowerCase()),
                        bankCode: bank?.bankCode || bank?.institutionCode
                    }
                })
                setOptions(data);
            }
            else{
                setOptions([]);
            }
        }
        // eslint-disable-next-line
    }, [banks]);


    const submitForm = async (e) => {
        e.preventDefault();
        if ((bulkUpload !== null) && (bulkUpload !== undefined)){
            const params = {
                file: bulkUpload,
            }
            const paramsFormData = jsonToFormData(params);
            dispatch(employeesActions.uploadEmployeesExcel(paramsFormData));
            // dispatch(employeesActions.uploadEmployeesExcelPrevew(paramsFormData));
        }
        else{
            toast.error("Please select a file to upload");
        }
    }
    
    const handleSuccessModalClose = () => {
        getEmployees();
        setIsBulkUploadSuccess(false);
    }
    
    // useEffect(() => {
    //     if (employeeBulkPreviewSuccess && employeeBulkPreview){
    //         // dispatch(employeesActions.resetEmployeeCreateSuccess());
    //             // history.push("/people/employees/add/upload-result/" + employeeCreateStatus?.jobId);
    //             // const params = {
    //             //     file: bulkUpload,
    //             // }
    //             // const paramsFormData = jsonToFormData(params);
    //             // dispatch(employeesActions.uploadEmployeesExcel(paramsFormData));
    //             setUploadJobId(employeeBulkPreview?.data?.jobId);
    //             setIsOpenBulkUploadReview((prevState) => !prevState);
    //             dispatch(employeesActions.uploadEmployeePreviewSuccessReset());
    //             setIsOpen(false);
    //     }
    // }, [employeeBulkPreviewSuccess, employeeBulkPreview]);
    
    useEffect(() => {
        if (employeeCreateStatus?.jobId && employeeCreateSuccess) {
            // setUploadJobId(employeeCreateStatus?.jobId);
            // setIsOpenBulkUploadReview((prevState) => !prevState);
            dispatch(employeesActions.resetEmployeeCreateSuccess());
            setIsBulkUploadSuccess(true);
            setIsOpen(false);
        }
    }, [employeeCreateStatus, employeeCreateSuccess]);

    // useEffect(() => {
    //     if (employeeBulkPreviewSuccess === true){
    //         // dispatch(employeesActions.resetEmployeeCreateSuccess());
    //         if (employeeBulkPreview){
    //             setIsOpenBulkUploadReview((prevState) => !prevState);
    //             setUploadJobId(employeeBulkPreview?.jobId)
    //             // history.push("/people/employees/add/upload-result/" + employeeCreateStatus?.jobId);
    //         }
    //     }
        // eslint-disable-next-line
    // }, [employeeBulkPreviewSuccess]);
    // useEffect(() => {
    //     if (employeeCreateSuccess === true){
    //         dispatch(employeesActions.resetEmployeeCreateSuccess());
    //         if (employeeCreateStatus?.jobId){
    //             setIsOpenBulkUploadReview((prevState) => !prevState);
    //             setUploadJobId(employeeCreateStatus?.jobId)
    //             // history.push("/people/employees/add/upload-result/" + employeeCreateStatus?.jobId);
    //         }
    //     }
    //     // eslint-disable-next-line
    // }, [employeeCreateSuccess]);
    
    const convertArrayToCSV = (array) => {
        const header = Object.keys(array[0])?.join(',');
        const rows = array?.map(obj => Object.values(obj).join(','));
        return [header, ...rows].join('\n');
    };
    
    const downloadCSV = (csv, filename) => {
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const DownloadCSVButton = () => {
        const handleDownload = () => {
            const csv = convertArrayToCSV(options);
            downloadCSV(csv, 'banks.csv');
        };
    
        return <button onClick={handleDownload}>Download Bank Name & Code CSV</button>;
    };

    return (
        <>
            <Maybe condition={isBulkUploadSuccess}>
                <FormDrawer 
                    display="center" 
                    size="lg" 
                    isOpen={isBulkUploadSuccess} 
                    setIsOpen={handleSuccessModalClose}
                >
                    <div className="p-6">
                        <div className="flex justify-center">
                            <div className="h-48 sm:h-56">
                                <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                            </div>
                        </div>

                        <div className="mt-4 py-2">
                            <div className="text-center text-[#4A5564] font-normal text-lg">
                                Employee Bulk Upload Successful
                            </div>
                        </div>

                        <div className="py-2 mt-4 flex justify-center gap-6">
                            <button 
                                type="button" 
                                className="btn btn-lg btn-block rounded-lg whitespace-nowrap text-white bg-ep-primary-600" 
                                onClick={handleSuccessModalClose}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </FormDrawer>
            </Maybe>
            <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[12px] flex justify-between">
                    <div>Add Bulk Employees</div>
                    <div onClick={() => setIsOpen(false)}><CloseOutIcon /></div>
                </div> 
                <div>Profile multiple employees</div> 
                <div className="flex justify-between py-4">
                    <div>Requirements</div>
                    <div className="text-[#00535C] underline" onClick={() => setShowBanks(showBanks => !showBanks)}>View Earnipay bank codes</div>
                </div>
                <div className="mt-1">
                    <BanksWithBankCodes showBanks={showBanks} banks={banks} banksLoading={banksLoading} />
                </div>
                <BulkAlertMessage />
                {/* {!banksLoading && <button className="w-full flex justify-end pt-[24px] text-[#00535C] underline">
                    <DownloadCSVButton />
                </button>
                } */}
                <div className="flex items-center justify-between py-[24px]">
                    <div>Upload CSV File</div>
                    <a href="https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com//bulk-upload-files/Bulk_Employee_List_Template_File.xlsx" target="_blank" rel="noreferrer" download className="flex text-[#00535C] underline items-center">
                        <DownloadIcon /> 
                        <span className="ml-2">Download a sample CSV file</span>
                    </a>
                </div>
                <form onSubmit={submitForm} className="">
                    <div className="h-60 border border-dashed border-gray-300 rounded-2xl overflow-hidden">
                        <Maybe condition={bulkUpload === null}>
                            <FileUploader handleChange={(e) => setBulkUpload(e)} multiple={false} types={["xls","xlsx", "csv"]} onTypeError={(err) => toast.error(err)} onSizeError={(err) => toast.error(err)}>
                                <FileUploadUI fileIcon={iconCSV} />
                            </FileUploader>
                        </Maybe>

                        <Maybe condition={bulkUpload !== null}>
                            {/* <div className="w-full h-full p-6 bg-[#FBFCFF] flex"> */}
                                <div className="flex w-full h-full p-6 bg-[#FBFCFF] items-center justify-between">
                                    <div className="flex">
                                        <img src={iconDocCsv} alt="file upload" className="object-contain mx-auto" />
                                    </div>
                                    <div className="mt-4 flex space-x-4 justify-between items-center">
                                        <div>
                                            <div className="">
                                                <div className="max-w-xs text-sm ellipsis">{bulkUpload?.name}</div>
                                                <div className="uppercase">{getFileSize(bulkUpload?.size)}</div>
                                            </div>
                                            <div className="flex justify-between items-center gap-2">
                                            <div className="w-full h-1 mt-1 bg-[#10B759] rounded-full"></div>
                                            <div className="text-sm">100%</div>
                                            </div>
                                        </div>
                                        <div>
                                            <img onClick={() => setBulkUpload(null)} src={redBinIcon} alt="file upload" className="object-contain mx-auto" />
                                            {/* <FontAwesomeIcon icon="times-circle" className="cursor-pointer hover:text-red-500" onClick={() => setBulkUpload(null)} /> */}
                                        </div>
                                    </div>
                                </div>
                        
                        </Maybe>
                    </div>

                    <div>
                        <div className="mt-6 flex justify-end space-x-4">
                        <button type="button" onClick={() => {
                            setBulkUpload(null);
                            setIsOpen(false);
                        }} className="btn btn-transparent-primary btn-md">
                            Cancel
                        </button>
                        <ButtonLoader type="submit" loading={employeeBulkPreviewLoading || employeeUploadLoading} className="btn btn-ep-primary btn-md" disabled={bulkUpload === null || bulkUpload === undefined}>
                            Continue
                        </ButtonLoader>
                    </div>
                    </div>

                </form>
                </div>
            </FormDrawer>
        </>
    )
}


const BanksWithBankCodes = (props) => {
    const dispatch = useDispatch();
    const { banks, banksLoading } = props;
    const [options, setOptions] = useState([]);


    useEffect(() => {
        dispatch(banksActions.getAllBanks());
        // eslint-disable-next-line
    }, []);
    


    useEffect(() => {
        if (banks?.error === false && banks){
            if (banks?.length > 0){
                const data = banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((bank) => {
                    return {
                        label: (bank?.bankName || bank?.institutionName) + " = #" + (bank?.bankCode || bank?.institutionCode),
                        value: bank?.bankCode || bank?.institutionCode
                    }
                })
                setOptions(data);
            }
            else{
                setOptions([]);
            }
        }
        // eslint-disable-next-line
    }, [banks]);
    

    return (
        <div>
            <Maybe condition={props.showBanks === true}>
                <Maybe condition={banksLoading === true}>
                    <Input type="text" label="" value="Loading banks..." disabled={true} />
                </Maybe>
                <Maybe condition={banksLoading === false}>
                    <Select options={options} placeholder="Search Bank" />
                </Maybe>
            </Maybe>
        </div>
    )
}


export default BulkUpload;
